import { render } from "./MainSales.vue?vue&type=template&id=fb31b586&scoped=true"
import script from "./MainSales.vue?vue&type=script&lang=js"
export * from "./MainSales.vue?vue&type=script&lang=js"

import "./MainSales.vue?vue&type=style&index=0&id=fb31b586&scoped=true&lang=css"

import exportComponent from "D:\\Proyectos\\ERP ELECTRONICO\\ERP-FRONT\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb31b586"]])

export default __exports__